import { quickFacts } from '@/mocks/home';

export default function Hero() {
  return (
    <section id="top" className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20editorial%20magazine%20backdrop%20with%20layered%20soft%20teal%20and%20warm%20cream%20paper%20textures%2C%20subtle%20geometric%20gradient%20shapes%2C%20minimal%20refined%20composition%2C%20generous%20negative%20space%2C%20soft%20directional%20light%2C%20artistic%20non-photographic%20style&width=1600&height=900&seq=xiaolan-hero-01&orientation=landscape"
          alt="小蓝视频官网入口专题合集背景"
          title="小蓝视频官网入口与下载指南"
          className="h-full w-full object-top object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/55 to-foreground-950/75" />
      </div>

      <div className="relative mx-auto w-full max-w-[1280px] px-4 py-14 md:px-6 md:py-20">
        <div className="max-w-3xl animate-fade-up">
          <span className="inline-flex items-center gap-2 rounded-full border border-background-50/25 bg-background-50/10 px-3 py-1.5 font-label text-xs tracking-[0.18em] text-background-100">
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-bookmark-3-line text-sm" />
            </span>
            官方入口 · 专题合集
          </span>

          <h1 className="mt-5 font-heading text-3xl font-black leading-tight text-background-50 md:text-5xl">
            小蓝视频官网入口与 APP 下载指南
          </h1>

          <p className="mt-5 max-w-2xl text-sm leading-7 text-background-200 md:text-base md:leading-8">
            这里汇总小蓝视频官方入口、APP 下载方式、最新地址与安装包获取路径，并说明在线看的使用方法。无论你是首次接触还是需要重新进入，都能快速找到可用渠道并顺利开始浏览。
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <a
              href="#download"
              className="flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-download-2-line text-base" />
              </span>
              获取安装包
            </a>
            <a
              href="#online"
              className="flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/30 bg-background-50/10 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-background-50/20"
            >
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-live-line text-base" />
              </span>
              进入在线看
            </a>
          </div>
        </div>

        <div className="mt-12 grid grid-cols-2 gap-3 md:mt-16 md:grid-cols-4 md:gap-5">
          {quickFacts.map((fact) => (
            <div
              key={fact.label}
              className="rounded-lg border border-background-50/15 bg-background-50/10 px-4 py-4 backdrop-blur-sm"
            >
              <div className="font-heading text-2xl font-bold text-background-50 md:text-3xl">{fact.value}</div>
              <div className="mt-1.5 text-xs text-background-200 md:text-sm">{fact.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}